export var CrossProductScope = /*#__PURE__*/function (CrossProductScope) {
  CrossProductScope["RECENTS"] = "rovo-cross-product.recents";
  CrossProductScope["RESULTS"] = "rovo-cross-product.results";
  return CrossProductScope;
}({});